<template>
  <div>
    <v-card flat>
      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Full Name:</p>
          </div>
          <div class="w-1/3 h-12">
            <p class="font-weight-medium">
              {{
                values.trainee
                    ? values.trainee.prefix
                        ? values.trainee.prefix
                        : ""
                    : ""
              }}
              {{
                values.trainee
                    ? values.trainee.firstName
                        ? values.trainee.firstName
                        : "-"
                    : "-"
              }}
              {{
                values.trainee
                    ? values.trainee.middleName
                        ? values.trainee.middleName
                        : "-"
                    : "-"
              }}
              {{
                values.trainee
                    ? values.trainee.lastName
                        ? values.trainee.lastName
                        : "-"
                    : "-"
              }}
            </p>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Phone Number:</p>
          </div>
          <div class="w-1/3 h-12">
            <p class="font-weight-medium">
              {{ values.trainee ? values.trainee.phoneNumber : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Trainee's Location:</p>
          </div>
          <div class="w-1/3 h-12">
            <p class="font-weight-medium">
              {{
                values.trainee ? (values.trainee.woreda ? (values.trainee.woreda.zone ?
                    (values.trainee.woreda.zone.location ? values.trainee.woreda.zone.location.name : "-") : "-") : "-") : "-"
              }}
            </p>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              Kebele:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{
                values.trainee
                    ? values.trainee.kebele
                        ? values.trainee.kebele
                        : "-"
                    : "-"
              }}
            </div>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              Trainee's Health Profession:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{
                values.trainee
                    ? values.trainee.healthProfession
                        ? values.trainee.healthProfession.name
                        : "-"
                    : "-"
              }}
            </div>
          </div>
          <div class="w-1/3 h-12">
          </div>
          <div class="w-1/3 h-12">
          </div>

        </div>
      </v-card-text>
    </v-card>

    <v-tabs>
      <v-tab>Course</v-tab>

      <v-tab-item>
        <div v-if="values.new_trainees_course">
          <v-card
              flat
          >
            <v-card-text>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">Course Name:</p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ values.new_trainees_course.course.courseName }}
                  </div>
                </div>
                <div>
                  <v-btn
                      v-if="$can('trainee', 'completeTraining') && (values.new_trainees_course.courseStatus === 'null')"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      @click="gotToCourseCompletion(values.new_trainees_course)"
                  >
                    <span>Complete Course</span>
                  </v-btn>
                  <v-btn
                      v-if="$can('trainee', 'generateCertificate') && (values.new_trainees_course.courseStatus === 'pass')"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      @click="generateCerteficate(values.new_trainees_course)"
                  >
                    <span>View Certificate</span>
                  </v-btn>
                  <v-btn
                      v-if="$can('trainee', 'emailCertificate') && (values.new_trainees_course.courseStatus === 'pass')"
                      class="white--text ml-2"
                      color="cyan"
                      dark
                      depressed
                      small
                      @click="sendCertificateEmail(values.new_trainees_course)"
                  >
                    <span>Send Certificate</span>
                  </v-btn>
                  <v-btn
                      v-if="values.new_trainees_course.courseStatus === 'pending'"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      disabled
                  >
                    <span>Pending Approval</span>
                  </v-btn>
                  <v-btn
                      v-if="values.new_trainees_course.courseStatus === 'fail'"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      @click="viewCourseDetail(values.new_trainees_course)"
                  >
                    <span>View Course</span>
                  </v-btn>
<!--                  <v-btn-->
<!--                      v-if="values.new_trainees_course.courseStatus !== 'null'"-->
<!--                      class="white&#45;&#45;text ml-2"-->
<!--                      color="cyan"-->
<!--                      dark-->
<!--                      depressed-->
<!--                      small-->
<!--                      @click="editCourseDetail(values.new_trainees_course)"-->
<!--                  >-->
<!--                    <span>Edit</span>-->
<!--                  </v-btn>-->
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Continuing Education Unit:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ values.new_trainees_course.course.continualEducationUnit }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Certificate Reason:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values.new_trainees_course.certificate_reason ?
                          values.new_trainees_course.certificate_reason.name : 'Not Certified Yet'
                    }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Score:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ values.new_trainees_course.score ? values.new_trainees_course.score : 'Not Certified Yet' }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Course Completion Date:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values.new_trainees_course.courseCompletionDate ? values.new_trainees_course.courseCompletionDate
                          : 'Not Certified Yet'
                    }}
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-divider></v-divider>
          </v-card>
        </div>
        <div v-else-if="values.newt_cat2_course">
          <v-card
              flat
          >
            <v-card-text>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">Course Name:</p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ values.newt_cat2_course.program.courseTitleCat2 }}
                  </div>
                </div>
                <div>
                  <v-btn
                      v-if="$can('trainee', 'completeTraining') && (values.newt_cat2_course.courseStatus === 'null')"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      @click="gotToCourseCompletion(values.newt_cat2_course)"
                  >
                    <span>Complete Course</span>
                  </v-btn>
                  <v-btn
                      v-if="$can('trainee', 'generateCertificate') && (values.newt_cat2_course.courseStatus === 'pass')"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      @click="generateCerteficate(values.newt_cat2_course)"
                  >
                    <span>View Certificate</span>
                  </v-btn>
                  <v-btn
                      v-if="$can('trainee', 'emailCertificate') && (values.newt_cat2_course.courseStatus === 'pass')"
                      class="white--text ml-2"
                      color="cyan"
                      dark
                      depressed
                      small
                      @click="sendCertificateEmail(values.newt_cat2_course)"
                  >
                    <span>Send Certificate</span>
                  </v-btn>
                  <v-btn
                      v-if="values.newt_cat2_course.courseStatus === 'pending'"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      disabled
                  >
                    <span>Pending Approval</span>
                  </v-btn>
                  <v-btn
                      v-if="values.newt_cat2_course.courseStatus === 'fail'"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      @click="viewCourseDetail(values.newt_cat2_course)"
                  >
                    <span>View Course</span>
                  </v-btn>
<!--                  <v-btn-->
<!--                      v-if="values.newt_cat2_course.courseStatus !== 'null'"-->
<!--                      class="white&#45;&#45;text ml-2"-->
<!--                      color="cyan"-->
<!--                      dark-->
<!--                      depressed-->
<!--                      small-->
<!--                      @click="editCourseDetail(values.newt_cat2_course)"-->
<!--                  >-->
<!--                    <span>Edit</span>-->
<!--                  </v-btn>-->
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Continuing Education Unit:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ values.newt_cat2_course.program.ceu }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Certificate Reason:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values.newt_cat2_course.certificate_reason ? values.newt_cat2_course.certificate_reason.name :
                          "Not Certified Yet"
                    }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Score:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ values.newt_cat2_course.score ? values.newt_cat2_course.score : "Not Certified Yet" }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Course Completion Date:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values.newt_cat2_course.courseCompletionDate ? values.newt_cat2_course.courseCompletionDate :
                          "Not Certified Yet"
                    }}
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-divider></v-divider>
          </v-card>
        </div>
        <div v-else>
          <v-card flat>
            <v-card-title> No courses to display!</v-card-title>
            <v-divider></v-divider>
          </v-card>
        </div>
      </v-tab-item>
    </v-tabs>

    <template>
      <v-dialog v-model="courseCompletionDialog" width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >{{ title }}
          </v-card-title
          >
          <v-divider></v-divider>
          <HrdTraineeCourseComplete
              v-if="courseCompletionDialog"
              :traineeStatus="traineeStatus.data"
              :traineeUpdateCourseDetail="traineeUpdateCourseDetail"
              :userInfo="newTrainee"
              traineeType="new"
              @close="refreshTrainee"
          ></HrdTraineeCourseComplete>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="viewCourseDialog" width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >{{ title }}
          </v-card-title
          >
          <v-divider></v-divider>
          <HrdTraineeViewCourse
              v-if="viewCourseDialog"
              :traineeStatus="traineeStatus.data"
              :traineeUpdateCourseDetail="traineeUpdateCourseDetail"
              :userInfo="newTrainee"
              traineeType="new"
              @close="viewCourseDialog = false"
          ></HrdTraineeViewCourse>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="editCourseDialog" width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >Edit Certificate
          </v-card-title
          >
          <v-divider></v-divider>
          <EditCertificate
              v-if="editCourseDialog"
              :traineeStatus="traineeStatus.data"
              :traineeUpdateCourseDetail="traineeUpdateCourseDetail"
              :userInfo="newTrainee"
              traineeType="new"
              @close="editCourseDialog = false"
          ></EditCertificate>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import HrdTraineeCourseComplete from "../hrd-trainee-course-complete.vue";
import HrdTraineeViewCourse from "../new-trainee/hrd-trainee-view-course.vue";
import {generateCertificate1, resolveCertificateEmail} from "../generate-certiificate";
import {generateCertificate2} from "../generate-certificate-non-course";
import {TraineeService} from "../trainees.service";
import EditCertificate from "../edit-certificate.vue";
import {settings} from "@/Settings";
import {isCertificateApprovalComplete} from "@/utils/helper";

export default {
  components: {
    HrdTraineeCourseComplete,
    HrdTraineeViewCourse,
    EditCertificate
  },
  props: {
    newTrainee: Object,
    traineeStatus: Object,
    traineStatusIds: Object,
    detailDialog: Boolean,
  },
  data() {
    return {
      values: [],
      traineeUpdateCourseDetail: {},
      courseCompletionDialog: false,
      viewCourseDialog: false,
      title: "",
      imageSrc: "",
      editCourseDialog: false
    };
  },
  methods: {
    resolveCourseStatus(course) {
      if (!course || course.traineeStatusId == null) {
        return "null";
      }
      if (course.traineeStatusId == this.traineStatusIds.passId) {
        return isCertificateApprovalComplete(course) ? "pass" : "pending";
      }
      return "fail";
    },
    gotToCourseCompletion(traineUpdateCouse) {
      this.courseCompletionDialog = true;
      this.traineeUpdateCourseDetail = traineUpdateCouse;
      this.title = "Course Completion Detail";
    },
    viewCourseDetail(traineUpdateCouse) {
      this.viewCourseDialog = true;
      this.traineeUpdateCourseDetail = traineUpdateCouse;
      this.title = "Course Detail";
    },
    async refreshTrainee(params) {
      this.courseCompletionDialog = false;

      if (!(params && (params.traineeUpdateId || params.newTraineesUpdateId))) {
        return;
      }

      const updateId = params.traineeUpdateId || params.newTraineesUpdateId;
      const traineeCourse = await TraineeService.traineeCourseByUpdateId(updateId);

      if (
          traineeCourse.data &&
          traineeCourse.data.data &&
          traineeCourse.data.data.newt_cat2_course
      ) {
        this.values.newt_cat2_course = traineeCourse.data.data.newt_cat2_course;
        this.values.newt_cat2_course.courseStatus = this.resolveCourseStatus(this.values.newt_cat2_course);
      } else if (traineeCourse?.data?.data?.new_trainees_course) {
        this.values.new_trainees_course = traineeCourse.data.data.new_trainees_course;
        this.values.new_trainees_course.courseStatus = this.resolveCourseStatus(this.values.new_trainees_course);
      }
    },
    async generateCerteficate(traineUpdateCouse, options = {}) {
      const {open = true, sendEmail = false} = options || {};
      if (this.resolveCourseStatus(traineUpdateCouse) !== "pass") {
        this.$toast.warning("Certificate must be passed and approved before it can be generated.");
        return;
      }
      const url = settings.FRONT_URL + "newTraineeInformation/" + this.newTrainee.id;
      const params = {
        url: url
      }

      if (sendEmail) {
        const email = this.resolveTraineeEmail();
        if (!email) {
          this.$toast.error("Trainee email is required to deliver the certificate.");
          return;
        }
      }

      const res = await TraineeService.generateQrCode(params);

      if (res.status === 200 || res.status === 201) {
        this.imageSrc = res.data;
        switch (res.data.status) {
          case 200 || 201:
            generateCertificate1(traineUpdateCouse, this.values, this.imageSrc.data, {open, sendEmail});
            break;
          case 500:
            this.$toast.error(res.data.message);
            break;
        }
        // this.historyLoading = false;
      } else {
        // this.historyLoading = false;
        this.$toast.error("Unable to generate trainee certificate, please try again");
      }
    },
    sendCertificateEmail(traineUpdateCouse) {
      return this.generateCerteficate(traineUpdateCouse, {open: false, sendEmail: true});
    },
    resolveTraineeEmail() {
      return resolveCertificateEmail(this.values);
    },
    generateNoneCourseCertificate(programData) {
      generateCertificate2(programData, this.values);
    },
    editCourseDetail(traineUpdateCouse) {
      this.editCourseDialog = true;
      this.traineeUpdateCourseDetail = traineUpdateCouse;
      this.title = "Edit Course Detail";
    },
  },
  created() {
    if (this.newTrainee != null) {
      this.values = this.newTrainee;
      if (this.values.new_trainees_course) {
        this.values.new_trainees_course.courseStatus = this.resolveCourseStatus(this.values.new_trainees_course);
      } else {
        this.values.newt_cat2_course.courseStatus = this.resolveCourseStatus(this.values.newt_cat2_course);
      }
    }
  },
};
</script>
